import { Alert, Col, Form, Radio, Row } from "antd";
import React, { useState } from "react";
import BaseModal from "../../../BaseModal/BaseModal";
import { useSubmit } from "../../../../api";
import { RubleIcon, ToolIcon, UrgentIcon } from "../../../../../../../../resource/icons";
import IconCheckbox from "../../../../../../../../components/icon-checkbox";
import { useSetModalVisible } from "../../../../model/modalState";
import InformationBlockModal from "../../../InformationBlockModal/InformationBlockModal";
import { typeMassActionsText } from "../../../InformationBlockModal/constants";

const { Item: FormItem, create: createForm } = Form;

const Container = ({ form, requests, onSuccess }) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const setModalVisible = useSetModalVisible();
  const [stateInfo, setStateInfo] = useState(false);
  const [state, setState] = useState(null)

  const { submitAsync: submitChargeable, loading: loadingChargeable } = useSubmit({
    url: '/Request/set_chargeable',
    errMsg: 'Не удалось изменить статус "Платная"',
    onSuccess,
  });
  
  const { submitAsync: submitImmediate, loading: loadingImmediate } = useSubmit({
    url: '/Request/set_immediate',
    errMsg: 'Не удалось изменить статус "Аварийная"',
    onSuccess,
  });
  
  const { submitAsync: submitInternal, loading: loadingInternal } = useSubmit({
    url: '/Request/set_internal',
    errMsg: 'Не удалось изменить статус "Внутренняя"',
    onSuccess,
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields(async (err, values) => {
      if (!err) {
        const hasTrueValue = Object.values(values).some(value => value === true);
        if(hasTrueValue) {
          setState(values);
          setStateInfo(true);
        } else {
          setModalVisible(false)
        }
      }
    })
  };

  const handleConfirmSubmit = async (e) => {
    e.preventDefault();

    try {
      const { IsInternal, isChargeable, isImmediate, toggleText } = state;
  
    const promises = [];

    if (IsInternal) {
      promises.push(
        submitInternal({
          ids: requests.map(({ id }) => id),
          value: { IsInternal: toggleText === 'Снять' ? false : true },
          requests,
        })
      );
    }

    if (isChargeable) {
      promises.push(
        submitChargeable({
          ids: requests.map(({ id }) => id),
          value: { ChargeableId: toggleText === 'Снять' ? 0 : 1 },
          requests,
        })
      );
    }

    if (isImmediate) {
      promises.push(
        submitImmediate({
          ids: requests.map(({ id }) => id),
          value: { ImmediateId: toggleText === 'Снять' ? 0 : 1 },
          requests,
        })
      );
    }

    await Promise.all(promises);
  
      setModalVisible(false);
      setStateInfo(false);
      resetFields();
    } catch(error) {
      return <Alert title={error.message} />
    }
  }

  const cancelSubmit = () => {
    setStateInfo(false);
    resetFields()
  }

  const isLoading = loadingChargeable || loadingImmediate || loadingInternal;

  return (
    <BaseModal
      onOk={stateInfo ? handleConfirmSubmit : handleSubmit}
      onCancel={cancelSubmit}
      title={stateInfo ? "Подтвердите изменения" : "Изменение признаков"}
      confirmLoading={isLoading}
      width={stateInfo ? 600 : 450}
    >
      {!stateInfo ? (
        <Form align="vertical">
         <Row gutter={16}>
           <Col span={24}>
             <FormItem style={{ width: "100%" }}>
               {getFieldDecorator("toggleText", {
                 initialValue: "Установить",
               })(
                 <Radio.Group style={{ width: "100%", display: 'flex' }}>
                   <Radio.Button value="Установить" style={{ flex: 1, textAlign: "center" }}>Установить</Radio.Button>
                   <Radio.Button value="Снять" style={{ flex: 1, textAlign: "center" }}>Снять</Radio.Button>
                 </Radio.Group>
               )}
             </FormItem>
           </Col>
         </Row>
 
         <Row gutter={16}>
               <Col span={8}>
                 <FormItem >
                   {getFieldDecorator('isChargeable', { initialValue: false })(
                     <IconCheckbox icon={<RubleIcon />}>
                       Платная
                   </IconCheckbox>)}
                 </FormItem>
               </Col>
               <Col span={8}>
                 <FormItem>
                   {getFieldDecorator('isImmediate', { initialValue: false })(
                     <IconCheckbox icon={<UrgentIcon />}>
                       Аварийная
                   </IconCheckbox>)}
                 </FormItem>
               </Col>
               <Col span={8}>
                 <FormItem >
                   {getFieldDecorator('IsInternal', { initialValue: false })(
                     <IconCheckbox icon={<ToolIcon />}>
                       Внутренняя
                   </IconCheckbox>)}
                 </FormItem>
               </Col>
          </Row>
       </Form>
      ) : (
        <InformationBlockModal typeMassActions={typeMassActionsText.sign} count={requests.length} state={state} />
      )
      }
    </BaseModal>
  )
}

const ChangeSign = createForm({
  name: 'mass_actions_sign',
})(Container);

export default ChangeSign;
